import '@/lib/typedef';
import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/direct';

export default {
	createDirect(params, cb, errorCb) {
		const url = `${endpoint}`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	createDirectPublic(params, cb, errorCb) {
		const url = `${endpoint}/public`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	getDirects(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
	updateDirect(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
	resendDirect(userId = null) {
		const itemKey = 'directData';
		const checkDirectData = localStorage.getItem(itemKey);
		const directData = (checkDirectData) ? JSON.parse(checkDirectData) : '';
		if (directData) {
			if (userId) {
				directData.user_id = userId;
				this.createDirectPublic(directData);
			} else {
				this.createDirect(directData);
			}
			localStorage.removeItem(itemKey);
		}
	},
};
